import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const tournamentsList = createAsyncThunk(
  "tournamentsList/tournamentsList",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("tournament/getall");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const tournamentsListSlice = createSlice({
  name: "tournamentsList",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(tournamentsList.pending, (state) => {
        state.loading = true;
      })
      .addCase(tournamentsList.fulfilled, (state, action) => {
          
          
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(tournamentsList.rejected, (state, action) => {
        
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default tournamentsListSlice.reducer;
